import styled from "styled-components";
import {CardBox} from "../../../../../basic-components/card/card.box";

export const FullGridLineBox = styled.div`
    grid-column: 1/-1;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: ${props => props.theme.spacing.flexGap24};
`

export const SectionTitleBox = styled(FullGridLineBox)`
    border-top: 1px solid ${props => props.theme.colors.dark};
    padding-top: ${props => props.theme.spacing.flexGap24};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    
`

export const FieldsContainerBox = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: ${props => props.theme.spacing.flexGap24};
    align-items: flex-end;
    width: 100%;
    ${props => props.theme.screenMediaQuery.sAndBelow} {
        grid-template-columns: 1fr;
    }
`

export const InfoLineBox = styled.div`
    width: 100%;
`

export const PsoAgreementContainerBox = styled(CardBox)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${props => props.theme.spacing.flexGap24};
    width: 100%;
`